<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['new_member'] == 1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="AddMember" enctype="multipart/form-data">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group mb-2">
                    <label for="exampleDataList">Member's Name</label> <small class="text-danger">*</small>
                    <input class="form-control" list="applicants" required @change="FilterMember"
                      v-model="applicant_name" placeholder="Enter Member's Name..." />
                    <datalist id="applicants">
                      <option v-for="item in applicants" :key="item.id">{{ item.name }}-{{ item.telephone }}-{{ item.nin
                        }}</option>
                    </datalist>
                  </div>
                  <div class="form-group mb-2">
                    <label>Telephone</label> <small class="text-danger">*</small>
                    <b-input-group prepend="+256">
                      <input v-model="telephone" placeholder="Enter Telephone" v-mask="'#########'" type="text" class="form-control"/>
                    </b-input-group>
                  </div>
                  <div class="row form-group mb-2">
                    <div class="col-6">
                      <label>Gender</label> <small class="text-danger">*</small>
                      <select class="form-control" v-model="gender">
                        <option>Male</option>
                        <option>Female</option>
                      </select>
                    </div>
                    <div class="col-6">
                      <label for="input-date1">Date of Birth</label> <small class="text-danger">*</small>
                      <input v-model="dateofbirth" type="date" class="form-control" />
                    </div>
                  </div>
                  <div class="form-group mb-2">
                    <label>Nationality</label> <small class="text-danger">*</small>
                    <v-select :options="countries" placeholder="Enter Nationality" v-model="nationality" label="name"
                      :reduce="nationality => nationality.id"></v-select>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Previous Member data">
                      <input type="file" class="form-control" v-on:change="onLogoChange" accept=".xlsx, .xls, .csv" />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <label>Email Address</label> <small class="text-danger">*</small>
                    <input v-model="email" type="email" required placeholder="Enter Email Address" class="form-control" />
                    <small class="text-muted">Login credentials will be sent to this email</small>
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="form-group mb-2">
                    <label>Address</label> <small class="text-danger">*</small>
                    <input v-model="address" placeholder="Enter Address" type="text" class="form-control" />
                  </div>
                  <div class="form-group mb-2">
                    <label>NIN Number</label> <small class="text-danger">*</small>
                    <input v-model="nin" required placeholder="National ID Number" type="text" class="form-control" />
                  </div>
                  <div class="form-group mb-2">
                    <label for="input-date1">Username</label> <small class="text-danger">*</small>
                    <input v-model="username" @input="CheckUsername()" required placeholder="Enter Username" type="text"
                      class="form-control" />
                  </div>
                  <div class="form-group mb-2">
                    <label>Saving Package</label> <small class="text-danger">*</small>
                    <v-select :options="savingpackages" placeholder="Enter Saving Package" v-model="savingpackage"
                      label="name" :reduce="savingpackage => savingpackage.id"></v-select>
                  </div>
                  <div class="form-group mb-2">
                    <label>Name of the Church</label> <small class="text-muted">(optional)</small>
                    <input v-model="churchname" placeholder="Name of the Church" type="text" class="form-control" />
                  </div>
                  
                  <div class="form-group mb-2">
                    <label>Sacco Member Id</label> <small class="text-muted">(optional)</small>
                    <input v-model="sacco_member_id" placeholder="Sacco Member Id" type="text" class="form-control" />
                  </div>
                </div>
                
                <div class="col-lg-4 border-start border-3">
                  <div class="form-group mb-2">
                    <label>Member Photo</label> <small class="text-muted">(optional)</small>
                    <div class="photo-upload-container">
                      <div class="photo-preview" v-if="memberPhotoPreview">
                        <img :src="memberPhotoPreview" alt="Member Photo" class="img-thumbnail" style="max-width: 150px; max-height: 150px;" />
                        <button type="button" @click="removePhoto" class="btn btn-danger btn-sm mt-1">Remove</button>
                      </div>
                      <div v-else class="photo-placeholder">
                        <div class="drop-zone" @dragover.prevent @drop.prevent="handleDrop">
                          <i class="fas fa-camera fa-2x text-muted"></i>
                          <p class="text-muted mt-0">Click or drag to upload photo</p>
                          <small class="text-muted">PNG, JPEG, JPG (Max 5MB)</small><br>
                          <input type="file" 
                                 class="form-control-file" 
                                 @change="onPhotoChange" 
                                 accept="image/png, image/jpeg, image/jpg"
                                 ref="photoInput"
                                 style="display: none;" />
                          <button type="button" @click="triggerPhotoUpload" class="btn btn-outline-primary btn-sm mt-2">
                            <i class="fas fa-upload"></i> Choose Photo
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-2">
                    <label>Next of Kin Name</label> <small class="text-muted">(optional)</small>
                    <input v-model="nokname" placeholder="NOK Name" type="text" class="form-control" />
                  </div>
                  <div class="form-group mb-2">
                    <label>Next of Kin Contact</label> <small class="text-muted">(optional)</small>
                    <input ref="nextInput" v-model="nokcontact" placeholder="NOK Contact" type="text"
                      class="form-control" />
                  </div>
                  <div class="form-group mb-2">
                    <label>Next of Kin Relation</label> <small class="text-muted">(optional)</small>
                    <input ref="nextInput" v-model="nokrelation" placeholder="NOK Relation" type="text"
                      class="form-control" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-8"></div>
                <div class="col-lg-4">
                  <b-button type="submit" :disabled="submitbtn <= false" class=" btn w-100" variant="primary">
                    <i class="fas fa-check-circle"></i> Register
                  </b-button>
                  <br>
                  <center><span class="text-danger">{{ error }}</span></center>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Add New Members</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { applicantMethods, applicantComputed, savingpackageMethods, savingpackageComputed, countriesMethods, countriesComputed } from "@/state/helpers";

export default {
  page: {
    title: "Add Member",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Add Member",
      items: [{ text: "Dashboard", href: "/" }, { text: "Members", active: true }],
      services: [],
      applicant_name: "",
      telephone: "",
      date_of_joining: new Date().toLocaleDateString('fr-CA'),
      dateofbirth: new Date().toLocaleDateString('fr-CA'),
      nationality: 229,
      age: "",
      gender: "Male",
      email: "",
      address: "",
      nin: "",
      username: "",
      nokname: "",
      nokcontact: "",
      sacco_member_id: '',
      sacco_member_file: '',
      savingpackage: '',
      churchname: "",
      nokrelation: "",
      submitbtn: true,
      error: "",
      member_data: '',
      country_code: '256',
      focused: false,
      // Photo upload properties
      memberPhoto: null,
      memberPhotoPreview: null,
      photoError: null,
    };
  },
  methods: {
    ...applicantMethods,
    ...countriesMethods,
    ...savingpackageMethods,
    
    onLogoChange(e) { 
      this.sacco_member_file = e.target.files[0]; 
    },

    // Photo upload methods
    onPhotoChange(e) {
      const file = e.target.files[0];
      this.handlePhotoFile(file);
    },

    triggerPhotoUpload() {
      this.$refs.photoInput.click();
    },

    handleDrop(e) {
      const file = e.dataTransfer.files[0];
      this.handlePhotoFile(file);
    },

    handlePhotoFile(file) {
      if (!file) return;
      
      // Validate file type
      const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      if (!validTypes.includes(file.type)) {
        this.photoError = 'Please upload a PNG, JPEG, or JPG image.';
        this.$toast.error('Invalid file type. Please upload PNG, JPEG, or JPG.');
        return;
      }

      // Validate file size (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        this.photoError = 'File size must be less than 5MB.';
        this.$toast.error('File size exceeds 5MB limit.');
        return;
      }

      this.photoError = null;
      this.memberPhoto = file;
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        this.memberPhotoPreview = e.target.result;
      };
      reader.readAsDataURL(file);
      
      this.$toast.success('Photo uploaded successfully');
    },

    removePhoto() {
      this.memberPhoto = null;
      this.memberPhotoPreview = null;
      this.$refs.photoInput.value = '';
    },

    memberFromApplicants() {
      this.applicant_name = this.$route.query.member_data.name;
      this.telephone = this.$route.query.member_data.telephone;
      this.gender = this.$route.query.member_data.gender;
      this.dateofbirth = this.$route.query.member_data.date_of_birth;
      this.address = this.$route.query.member_data.address;
      this.nin = this.$route.query.member_data.nin;
      this.email = this.$route.query.member_data.email;
    },

    removeCountryNumber() {
      this.country_code = this.country_code.phonecode;
    },

    async FilterMember() {
      let url = `/findapplicant/${this.applicant_name}`;
      await axios.get(url).then((response) => {
        if (response.data.applicants) {
          this.telephone = response.data.applicants[0].telephone;
          this.dateofbirth = response.data.applicants[0].date_of_birth;
          this.address = response.data.applicants[0].address;
          this.nin = response.data.applicants[0].nin;
          this.email = response.data.applicants[0].email;
          this.gender = response.data.applicants[0].gender;
        }
      });
    },

    async CheckUsername() {
      let formData = new FormData();
      formData.append("username", this.username);
      let url = "/checkusername";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          if (response.data == 1) {
            this.error = 'Username Already Taken';
            this.submitbtn = false;
          } else {
            this.error = "";
            this.submitbtn = true;
          }
        }
      });
    },

    async AddMember() {
      // Validate email
      if (!this.email) {
        this.error = "Email address is required";
        this.$toast.error("Please enter member's email address");
        this.submitbtn = true;
        return;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.error = "Please enter a valid email address";
        this.$toast.error("Invalid email format");
        this.submitbtn = true;
        return;
      }

      this.error = "Saving Member Visit";
      this.submitbtn = false;
      
      let formData = new FormData();
      formData.append("member", this.applicant_name);
      formData.append("date_of_joining", this.date_of_joining);
      formData.append("telephone", this.telephone);
      formData.append("gender", this.gender);
      formData.append("date_of_birth", this.dateofbirth);
      formData.append("nationality", this.nationality);
      formData.append("address", this.address);
      formData.append("email", this.email);
      formData.append("nin", this.nin);
      formData.append("username", this.username);
      formData.append("nokname", this.nokname);
      formData.append("nokcontact", this.nokcontact);
      formData.append("sacco_member_id", this.sacco_member_id);
      formData.append("savingpackage", this.savingpackage);
      formData.append("member_file", this.sacco_member_file);
      formData.append("churchname", this.churchname);
      formData.append("nokrelation", this.nokrelation);
      
      // Append photo if exists
      if (this.memberPhoto) {
        formData.append("member_photo", this.memberPhoto);
      }
      
      let url = "/addmember";
      try {
        await axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          if (response.status == 200) {
            this.fetchApplicants();
            this.applicant_name = "";
            this.telephone = "";
            this.address = "";
            this.email = "";
            this.nin = "";
            this.username = "";
            this.nokname = "";
            this.nokcontact = "";
            this.sacco_member_id = "";
            this.savingpackage = "";
            this.sacco_member_file = "";
            this.churchname = "";
            this.nokrelation = "";
            this.memberPhoto = null;
            this.memberPhotoPreview = null;
            this.$toast.success("New Member Added Successfully. Welcome email has been sent.");
            this.error = "";
            this.submitbtn = true;
          }
        });
      } catch (error) {
        this.error = "Error Adding Member. Please check all required fields.";
        this.submitbtn = true;
        this.$toast.error("Failed to add member. Please try again.");
      }
    },
  },
  computed: {
    ...applicantComputed,
    ...countriesComputed,
    ...savingpackageComputed,
  },
  created() {
    this.fetchApplicants();
    this.fetchSavingPackages();
    this.fetchCountries();
  },
  mounted() {
    if (this.$route.query.member_data) {
      this.memberFromApplicants();
    }
  },
};
</script>

<style scoped>
.photo-upload-container {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  transition: all 0.3s ease;
  background: #f8f9fa;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.photo-upload-container:hover {
  border-color: #0d6efd;
  background: #f0f7ff;
}

.photo-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.photo-preview img {
  border-radius: 8px;
  object-fit: cover;
}

.drop-zone {
  width: 100%;
  padding: 10px;
  cursor: pointer;
}

.drop-zone i {
  display: block;
  margin-bottom: 5px;
}

.photo-placeholder {
  width: 100%;
}

.form-control-file {
  display: none;
}

.text-danger {
  font-size: 0.875rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .border-start {
    border: none !important;
    padding-top: 20px;
    border-top: 3px solid #dee2e6 !important;
  }
}
</style>